import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimoniosSection() {
  const testimonials = [{
    quote: 'Me dio recursos listos y me ordenó el año completo de Geografía. Lo recomiendo a todos mis colegas.',
    name: 'María Fernanda López',
    role: 'Docente de Geografía',
    city: 'Buenos Aires'
  }, {
    quote: 'Arranqué marzo con todo armado. Los cuadernillos cubren todos los ejes que necesito.',
    name: 'Carlos Andrés Ruiz',
    role: 'Profesor de Geografía',
    city: 'Córdoba'
  }, {
    quote: 'Muy completo y adaptable a mi planificación provincial. Mis alumnos entienden mucho mejor con este material.',
    name: 'Luciana Gómez',
    role: 'Docente de secundaria',
    city: 'Rosario'
  }, {
    quote: 'Como directora, lo compré para todo el departamento de Ciencias Sociales. Nos ahorró meses de planificación.',
    name: 'Paula Martínez',
    role: 'Directora de escuela',
    city: 'Mendoza'
  }, {
    quote: 'Siendo estudiante de profesorado, este kit me adelantó años de experiencia práctica en Geografía.',
    name: 'Valentina Sánchez',
    role: 'Estudiante de profesorado',
    city: 'La Plata'
  }];
  return <section id="testimonios" className="py-8 sm:py-14 bg-[#0f172a]" data-id="element-225">
      <div className="max-w-6xl mx-auto px-3 sm:px-6" data-id="element-226">
        <div className="text-center mb-6 sm:mb-10" data-id="element-227">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-white mb-2 sm:mb-3" data-id="element-228">
            Testimonios de docentes
          </h2>
          <p className="text-gray-400 text-xs sm:text-base" data-id="element-229">
            Lo que dicen quienes ya están usando el kit en sus aulas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4" data-id="element-230">
          {testimonials.map((t, i) => <div key={i} className="bg-[#1e293b] p-4 sm:p-6 rounded-xl border border-gray-700 relative hover:border-gray-500 transition-colors" data-id="element-231">
              <Quote className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-600 h-5 w-5 sm:h-6 sm:w-6 opacity-50" data-id="element-232" />

              <div className="flex gap-0.5 mb-2 sm:mb-3" data-id="element-233">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#fbbf24] fill-current" data-id="element-234" />)}
              </div>

              <p className="text-gray-200 text-xs sm:text-sm italic mb-3 sm:mb-4 leading-relaxed" data-id="element-235">
                "{t.quote}"
              </p>

              <div className="mt-auto" data-id="element-236">
                <p className="text-white font-bold text-xs sm:text-sm" data-id="element-237">
                  {t.name}
                </p>
                <p className="text-gray-400 text-[10px] sm:text-xs" data-id="element-238">{t.role}</p>
                <p className="text-gray-500 text-[9px] sm:text-[10px] mt-0.5" data-id="element-239">
                  {t.city}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}